import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form } from 'react-form';
import swal from 'sweetalert2';
import Uppy from 'uppy/lib/core';
import { Dashboard } from 'uppy/lib/react';
import * as MesAct from '../../Actions/MesActions';
import { envoyerMessageNG, envoyerMessage, envoyerMessageNGPJ, envoyerMessageNGHorsPJ } from '../../App_Code/API';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { AfficherFeedback, Texte, ZoneTexte } from '../ChampFormulaire';
import { obtenirPrestation } from '../../App_Code/API';
import IconeBureau from '../../App_Data/IconeBureau';

const francaisCore = {
    strings: {
        youCanOnlyUploadX: {
            0: 'Vous pouvez joindre %{smart_count} fichier au maximum',
            1: 'Vous pouvez joindre %{smart_count} fichiers au maximum',
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files',
        },
        exceedsSize: 'Ce fichier dépasse la taille maximale autorisée : ',
        youCanOnlyUploadFileTypes: 'Types de fichiers pris en charge :',
        uppyServerError: 'Connection with Uppy Server failed',
    },
};

const francaisDashboard = {
    strings: {
        selectToUpload: 'Select files to upload',
        closeModal: 'Close Modal',
        upload: 'Upload',
        importFrom: 'Import from',
        dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
        dashboardTitle: 'Uppy Dashboard',
        copyLinkToClipboardSuccess: 'Link copied to clipboard.',
        copyLinkToClipboardFallback: 'Copy the URL below',
        copyLink: 'Copy link',
        fileSource: 'File source',
        done: 'Done',
        name: 'Name',
        removeFile: 'Remove file',
        editFile: 'Edit file',
        editing: 'Editing',
        finishEditingFile: 'Finish editing file',
        localDisk: 'Local Disk',
        myDevice: 'My Device',
        dropPasteImport: 'Drop files here, paste, import from one of the locations above or',
        dropPaste: 'Glissez-déposez vos fichiers ici, ou',
        browse: 'cliquez ici pour les sélectionner',
        fileProgress: 'File progress: upload speed and ETA',
        numberOfSelectedFiles: 'Number of selected files',
        uploadAllNewFiles: 'Upload all new files',
        emptyFolderAdded: 'No files were added from empty folder',
        uploadComplete: 'Upload complete',
        resumeUpload: 'Resume upload',
        pauseUpload: 'Pause upload',
        retryUpload: 'Retry upload',
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files',
        },
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files',
        },
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}',
        },
    },
};

const Icone = ({path, couleur}) => (
    <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={22} height={22} style={{filter: "invert(1)"}}>
        <image xlinkHref={path} width={22} height={22}/>
     </svg>
);

function recurseenvoyer(nbFichiers, numFichier, numAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, appelant) {
    numFichier+=1
    if(numFichier>nbFichiers) {
        envoyerMessageNGHorsPJ(numAuto, { Objet: sObjet, Memo: Memo, LesArcDocs: lesArcDocs, Bureau: bureau, Action: action, Prest: prest}).then((data) => {
            if (data && data > 0) {
                swal('Envoyé', 'Le message a été envoyé avec succès.', 'success');
                if (appelant.unblock) appelant.unblock();
                appelant.props.actions.mesObtenirMessages();
                appelant.props.history.push('/MaMessagerie');
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
            }
            });
    } else {
        envoyerMessageNGPJ(numAuto, LsFichiers[numFichier-1]).then((data) => {
            if (data) {
                if (data.length>0) {
                    if (numFichier==1) {
                        lesArcDocs=data
                    } else {
                        lesArcDocs += "," + data
                    }
                }
                recurseenvoyer(nbFichiers, numFichier, numAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, appelant)
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé. (taille du fichier trop importante)', 'error');
            }
        });
    }
}

class PageEcrire extends Component {
    constructor(props) {
        super(props);

        this.inputObjet = React.createRef();
        this.inputMemo = React.createRef();
        this.boutonEnvoyer = React.createRef();

        this.uppy = Uppy({
            debug: false,
            autoProceed: true,
            restrictions: {
                maxFileSize: 209715200,
                maxNumberOfFiles: 10,
                allowedFileTypes: ['image/*', 'text/*', 'application/pdf'],
            },
            locale: francaisCore,
        })
            .on('upload', () => this.setState({ LsFichiers: [] }))
            .on('complete', this.handleComplete)
            .on('file-removed', this.handleFileRemoved)
            .run();

        this.defaultValues = {
            Objet: '',
            Memo: `Bonjour,\n\n\n\nCordialement\n${this.props.Nom}`,
            Precedent: '',
        };
        //mettre estReponse a true par defaut lors de la publication de la nouvelle messagerie
        this.state = {
            estReponse: false,
            message : null,
            prest : null,
            NumAuto: 0,
            LsFichiers: [],
        };

        if (this.props.location.state && this.props.location.state.Mes) {
            const { NumAuto, Objet, Memo } = this.props.location.state.Mes;
            const sObjet = Objet.startsWith('RE :') || Objet.startsWith('Re:') ? Objet : `RE : ${Objet}`;

            this.defaultValues.Objet = sObjet;
            this.defaultValues.Precedent = Memo;
            this.state.estReponse = true;
            this.state.NumAuto = NumAuto;
        }
    }

    componentDidMount() {
        const { location, history } = this.props;
        if (!location.state || !location.state.Mes) {
            const chemin = location.pathname.slice(1).split('/');
            history.push(chemin && chemin[0] ? `/${chemin[0]}` : '/');
            return;
        }
        //récupère les info du message précédent & la prestation
        this.setState({ message: location.state.Mes });
        obtenirPrestation(location.state.Mes.Prest).then((prest) => {
            this.setState({ prest });
        });
    }

    componentWillUnmount() {
        this.uppy.close();
        if (this.unblock) this.unblock();
    }

    handleChange = (formState) => {
        const affichePrompt =
            formState.values.Objet !== this.defaultValues.Objet || formState.values.Memo !== this.defaultValues.Memo;
        if (!this.unblock && affichePrompt) {
            this.unblock = this.props.history.block("Vous n'avez pas envoyé le message.<br>Voulez-vous vraiment quitter cette page ?");
        } else if (this.unblock && !affichePrompt) {
            this.unblock();
        }
    };

    handleFileRemoved = (file) => {
        this.setState(prevState => ({
            LsFichiers: prevState.LsFichiers.filter(fichier => fichier.Nom !== file.name),
        }));
    };

    handleComplete = (result) => {
        result.successful.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (upload) => {
                this.setState(prevState => ({
                    LsFichiers: [...prevState.LsFichiers, { Data: upload.target.result.split(',')[1], Nom: file.name }],
                }));
            };

            reader.readAsDataURL(file.data);
        });
    };

    handleSubmit = (submittedValues) => {
        const { Objet, Memo } = submittedValues;
        const { NumAuto, LsFichiers, estReponse, message} = this.state;
        const sObjet = this.props.location.state && this.props.location.state.Incident ? `Problème signalé : ${Objet}` : Objet;
        //const sMemo = `${Memo}\n${this.props.Nom}`;
        this.boutonEnvoyer.current.disabled = true;

        const ObjetValide = estReponse ? true : this.defaultValues.Objet !== Objet;
        AfficherFeedback(this.inputObjet, ObjetValide);

        const MemoValide = this.defaultValues.Memo !== Memo;
        AfficherFeedback(this.inputMemo, MemoValide);

        if (!ObjetValide || !MemoValide) {
            this.boutonEnvoyer.current.disabled = false;
            return;
        }
        let prest = message.Prest
        let bureau = message.Bureau
        let action = "REP"
        // envoyerMessageNG(NumAuto, { Objet: sObjet, Memo: Memo, LsFichiers, Bureau: bureau, Action: action, Prest: prest }).then((data) => {
        //     if (data && data > 0) {
        //         swal('Envoyé', 'Le message a été envoyé avec succès.', 'success');
        //         if (this.unblock) this.unblock();
        //         this.props.actions.mesObtenirMessages();
        //         this.props.history.push('/MaMessagerie');
        //     } else {
        //         swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
        //         this.boutonEnvoyer.current.disabled = false;
        //     }
        // });

        let nbFichiers = 0
        if (LsFichiers != undefined) {
            nbFichiers = LsFichiers.length           
        }
        
        let numFichier = 0
        let lesArcDocs = ""
        recurseenvoyer(nbFichiers, numFichier, NumAuto, sObjet, Memo, lesArcDocs, LsFichiers, bureau, action, prest, this)
        this.boutonEnvoyer.current.disabled = false;
    };

    render() {
        const { estReponse, message, prest } = this.state;
        return (
            <Form
                defaultValues={this.defaultValues}
                onChange={formState => this.handleChange(formState)}
                onSubmit={submittedValues => this.handleSubmit(submittedValues)}
            >
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        { message && (
                            <div className="row mb-2">
                                <div className="col-6 col-xl-4">
                                    <span className="text-muted mr-2">Type : </span>
                                    <IconeBureau idBureau={message.Bureau} taille={"fa-lg"} title={message.LibBureau} />
                                </div>
                                <div className="row col-6 col-xl-4">
                                    <span className="text-muted mr-2">Catégorie : </span>
                                    { prest && prest.Icone ? 
                                            <div className="d-flex align-items-center justify-content-center" title={message.LibPrest} style={{height:25,width:25,borderRadius:'50%',backgroundColor:prest.Couleur}}>
                                                <Icone path={prest.Icone} couleur={prest.Couleur} /> 
                                            </div> : 
                                            <div className="d-flex align-items-center justify-content-center" style={{height:28,width:28,color:"#6c757d"}} title={message.LibPrest}>
                                            <svg width="25" height="25" viewBox="0 0 16 16" className="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                                            </svg>
                                        </div>
                                    }
                                </div>
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12 col-xl-8">
                                <div className="form-group required">
                                    <label htmlFor="Objet">Objet</label>
                                    <Texte
                                        field="Objet"
                                        id="Objet"
                                        type="text"
                                        readOnly={estReponse}
                                        refRef={this.inputObjet}
                                        maxLength={100}
                                    />
                                    <div className="invalid-feedback">Veuillez renseigner un objet</div>
                                </div>
                                <div className="form-group required">
                                    <label htmlFor="Memo">Message</label>
                                    <ZoneTexte
                                        field="Memo"
                                        id="Memo"
                                        type="text"
                                        rows={estReponse ? '6' : '12'}
                                        refRef={this.inputMemo}
                                    />
                                    <div className="invalid-feedback">Veuillez saisir un message</div>
                                </div>
                            </div>
                            <div className="col-12 col-xl-4" style={{alignSelf: "center"}}>
                                <div className="form-group optionnal">
                                    <label htmlFor="inputPJ">Pièces jointes</label>
                                    <div className="uppy-container mb-3">
                                        <Dashboard
                                            uppy={this.uppy}
                                            width={10000}
                                            height={225}
                                            locale={francaisDashboard}
                                            hideUploadButton
                                            proudlyDisplayPoweredByUppy={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group text-center">
                            <button type="submit" className="btn btn-success" ref={this.boutonEnvoyer}>
                                Envoyer le message
                            </button>
                        </div>
                        {estReponse && (
                            <div className="form-group optionnal">
                                <label htmlFor="Precedent">Message précédent</label>
                                <ZoneTexte
                                    className="form-control"
                                    field="Precedent"
                                    id="Precedent"
                                    type="text"
                                    rows="6"
                                    readOnly
                                />
                            </div>
                        )}
                    </form>
                )}
            </Form>
        );
    }
}
PageEcrire.displayName = 'PageEcrire';

function mapStateToProps({
    ProStore: {
        Pro : {Ind: { Nom }},
    }
}) {
    return { Nom };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(PageEcrire);



// WEBPACK FOOTER //
// ./src/components/MaMess/PageEcrire.js